const LoadingSpinner = ({ color = "#403E3E", showText = false }) => (
  <div className="loading-container" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px', minHeight: '200px', width: '100%'}}>
    <svg width="35" height="35" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 3.33334C16.0822 3.33334 12.3288 4.68571 9.39411 7.15609C6.45943 9.62646 4.53427 13.0496 3.97269 16.7977C3.41111 20.5458 4.24273 24.3769 6.32676 27.5345C8.41078 30.6921 11.6211 32.9823 15.3333 33.9733"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 20 20"
          to="360 20 20"
          dur="1s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
    {showText && <p style={{color: '#787878', fontSize: '12px'}}>Loading Election Results...</p>}
  </div>
);

export default LoadingSpinner;
